import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthorization } from '../../context/AuthorizationContext'

interface RequirePermissionProps {
  permission: string
  children: React.ReactNode
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission, children }) => {
  const { hasPermission } = useAuthorization()

  if (!hasPermission(permission)) {
    return <Navigate to="/unauthorized" replace />
  }

  return <>{children}</>
}

export default RequirePermission
